import Head from "next/head";
import { make as AugmentsInfoPage } from "../../../src/info/AugmentsInfoPage.bs";

export default function AugmentsInfo() {
  return (
    <>
      <Head>
        <title>Augments Set 5.5 TFT Info</title>
      </Head>
      <AugmentsInfoPage set={56} />
    </>
  );
}
